import { useEffect, useState } from 'react';

import { TableModalProps } from '../types/distribuicaoTypes';
import { getLeadsByUser } from '../utils/getLeadsByUser';

export const TableModal = ({
  data,
  identification,
  handleChangeSeller,
  handleShowToast,
  objForDistributionInput
}: TableModalProps) => {
  const [loading, setLoading] = useState(false);

  const handleLoading = () => {
    let load;
    if (!data || data.length === 0) {
      load = true;
    } else {
      load = false;
    }
    setLoading(load);
  };

  useEffect(() => {
    handleLoading();
  }, [data]);

  useEffect(() => {
    if (identification === 'distribuicao') {
      objForDistributionInput.handleClearInputValue();
    }
  }, [identification]);

  return (
    <div className="tw-mt-[20px] tw-max-h-[360px] tw-overflow-y-auto tw-rounded-3xl tw-shadow-lg">
      {!loading ? (
        <table className="tw-w-[100%] tw-rounded-3xl ">
          <thead className="tw-sticky tw-top-0">
            <tr className="tw-h-[100px] tw-bg-[#F5F5F5]">
              <th className="tw-text-left tw-pl-[30px] tw-py-[25px] tw-rounded-tl-[24px]">{`Vendedores (${
                data?.length !== undefined ? data?.length : 0
              })`}</th>
              <th className="tw-pr-[30px] tw-py-[25px] tw-rounded-tr-[24px]">
                {identification === 'distribuicao'
                  ? 'Quantidade'
                  : 'Leads na carteira '}
              </th>
            </tr>
          </thead>
          <tbody className="">
            {data?.map((item, index) => {
              return (
                <tr
                  key={index}
                  className={`${
                    index + 1 !== data.length &&
                    'tw-border-b-[1px] tw-border-[#D4D7DE]'
                  } `}
                  onClick={() => handleChangeSeller(item)}
                >
                  <td
                    className={`tw-bg-[#FFFFFF] tw-py-[20px] ${
                      index + 1 === data.length && 'tw-rounded-bl-[25px]'
                    }  tw-text-left tw-flex tw-flex-col tw-gap-[5px]`}
                  >
                    <span className="tw-ml-[30px] tw-w-auto md:tw-w-[90%] tw-break-words tw-whitespace-pre-wrap">
                      {item?.nome}
                    </span>

                    <p
                      className={`tw-ml-[30px] tw-text-center tw-rounded-[7.5px] tw-p-[3.5px] tw-text-[#FFFFFF]`}
                    >
                      {' '}
                      {item?.tipo === 'gestor' && 'Gestor'}
                    </p>
                  </td>
                  <td
                    className={`tw-bg-[#FFFFFF] tw-px-[20px] md:tw-px-0 ${
                      index + 1 === data.length && 'tw-rounded-br-[25px]'
                    } tw-text-center tw-font-bold tw-text-[1.25rem]`}
                  >
                    {identification === 'distribuicao' ? (
                      <input
                        type="number"
                        placeholder="0"
                        max={0}
                        min={0}
                        value={objForDistributionInput.inputValues[index] || ''}
                        onChange={(event) =>
                          objForDistributionInput.handleValueChange(
                            event.target.value,
                            index
                          )
                        }
                        className="tw-text-center tw-w-full tw-max-w-[85px] tw-border-[1px] tw-border-stone-900 tw-rounded-md"
                      />
                    ) : (
                      <>{item?.leads_disponiveis || 0}</>
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      ) : (
        <div className="tw-w-full tw-h-[250px] tw-flex tw-items-center tw-justify-center">
          <div className="spinner"></div>
        </div>
      )}
    </div>
  );
};
